import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlaygroundService {
  private playgroundSubject = new BehaviorSubject<any>(this.getCurrentPlayground());
  playground$ = this.playgroundSubject.asObservable();

  getCurrentPlayground() {
    const playground = localStorage.getItem('businessData');
    return playground ? JSON.parse(playground) : null;
  }

  setCurrentPlayground(playground: any) {
    localStorage.setItem('businessData', JSON.stringify(playground));
    localStorage.setItem('af', JSON.stringify(playground.availableFeatures));
    this.playgroundSubject.next(playground);
  }
}